import { gql } from '@apollo/client';

export const GET_USER_AVATAR_IMAGE = gql(`
  query GetImageSignedUrlWeb($data: GetImageSignedUrlWebInput) {
    getImageSignedUrlWeb(data: $data) {
      key
      signedUrl
    }
  }
`);

export const PHONE_NUMBER_EXIST = gql(`
  query IsPhoneNoExistWeb($data: IsPhoneNoExistWebInput!) {
    isPhoneNoExistWeb(data: $data) {
      phoneNoExist
    }
  }
`);
